import React from 'react';
import logo from './logo.png'

const Logo = () => (
    <img src={logo} alt="Logo" style={{width: "50px", margin: "0" }}/>
)

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Nav/Logo.js